var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.subpageTittle)?_c('div',{staticClass:"subpage-title"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.subpageTittle))]),_c('span',{staticClass:"desc"},[_vm._v(_vm._s(_vm.subpageDese))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }